// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__G6AyV","tooltipArrow":"Tooltip_tooltipArrow__TjcJQ"};